import styled, { css } from 'styled-components';

import {
  colorBlack200,
  colorBlack900,
  colorLink400,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from '@/styleUtils';

export const Wrapper = styled.div`
  ${({ $defaultStyles, $isBottomLinkBlocksStyles }) => {
    if (!$defaultStyles) {
      return css`
        text-align: center;
        width: 100vw;
        max-width: 1000px;
        overflow: auto;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;

        &::-webkit-scrollbar {
          display: none;
        }
      `;
    }
    if ($isBottomLinkBlocksStyles) {
      return css`
        flex-basis: 100%;
        @media ${mediaQueryMobileLargeMin} {
          flex-basis: 50%;
        }
      `;
    }

    return css`
      display: flex;
      flex-direction: column;
    `;
  }}
`;

export const Inner = styled.div`
  width: auto;
  display: inline-block;
  ${({ $defaultStyles }) => {
    if ($defaultStyles) {
      return css`
        display: flex;
        flex-direction: column;
        gap: 8px;
      `;
    }

    return '';
  }}
`;

export const Link = styled.a`
  font-family: ${fontFamilyPrimary};
  display: inline-block;
  padding: 10px 0;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${colorBlack200};
  cursor: pointer;
  margin-right: 16px;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border-bottom: 2px solid ${colorLink400};
  }
  ${({ $defaultStyles }) => {
    if ($defaultStyles) {
      return css`
        font: 400 14px/24px ${fontFamilyPrimary};
        color: ${colorLink400};
        text-transform: none;
        letter-spacing: 0;
        padding: 0;

        &:hover {
          opacity: 0.8;
        }

        &.active,
        &:visited {
          color: ${colorLink400};
          border-bottom: none;
        }
      `;
    }

    return '';
  }}
`;
export const Title = styled.h3`
  font: 700 18px/22px ${fontFamilySecondary};
  font-family: 'Raleway', sans-serif;
  color: ${colorBlack900};
  white-space: pre-wrap;
`;
